export const CHANNELS = [
  { id: "Meta", label: "Meta Ads" },
  { id: "TikTok", label: "TikTok Ads" },
  { id: "GoogleAds", label: "Google Ads" },
  { id: "OrganicSearch", label: "Organic Search" },
  { id: "OrganicSocial", label: "Organic Social" },
  { id: "Direct", label: "Direct" },
  { id: "Referral", label: "Referral" },
  { id: "Email", label: "Email" },
  { id: "Other", label: "Other" },
  { id: "Unknown", label: "Unknown" },
];

export const TRAFFIC_KINDS = [
  { id: "Paid", label: "مدفوع" },
  { id: "Organic", label: "أورجانيك" },
  { id: "Direct", label: "مباشر" },
  { id: "Other", label: "أخرى" },
  { id: "Unknown", label: "غير معروف" },
];

export const SHIPPING_STATES = [
  { id: "DELIVERED", label: "تم التسليم" },
  { id: "IN_TRANSIT", label: "في الطريق" },
  { id: "OUT_FOR_DELIVERY", label: "خارج للتوصيل" },
  { id: "FAILED_ATTEMPT", label: "محاولة فاشلة" },
  { id: "RETURNED", label: "مرتجع" },
  { id: "RETURN_IN_PROGRESS", label: "المرتجع في الطريق" },
  { id: "PENDING", label: "قيد التجهيز" },
  { id: "CANCELLED", label: "شحن ملغي" },
  { id: "UNSYNCED", label: "غير متزامن" },
];

const CHANNEL_CLASS = {
  Meta: "bg-blue-100 text-blue-800",
  TikTok: "bg-slate-900 text-white",
  GoogleAds: "bg-emerald-100 text-emerald-800",
  OrganicSearch: "bg-sky-100 text-sky-800",
  OrganicSocial: "bg-fuchsia-100 text-fuchsia-800",
  Direct: "bg-slate-100 text-slate-700",
  Referral: "bg-amber-100 text-amber-800",
  Email: "bg-indigo-100 text-indigo-800",
  Other: "bg-orange-100 text-orange-800",
  Unknown: "bg-rose-50 text-rose-700",
};

export function channelLabel(channel, fallback) {
  if (fallback) return fallback;
  return CHANNELS.find((item) => item.id === channel)?.label || "Unknown";
}

export function AttributionBadge({ channel, label }) {
  const key = channel || "Unknown";
  const text = label || channelLabel(key);
  return (
    <span className={`inline-flex rounded-full px-2 py-0.5 text-[11px] font-semibold ${CHANNEL_CLASS[key] || CHANNEL_CLASS.Unknown}`}>
      {text}
    </span>
  );
}
